import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ProviderEntity } from '../models/provider';

type ProviderSliceState = {
  data: ProviderEntity[] | null;
  loading: boolean;
};

const initialState: ProviderSliceState = {
  data: null,
  loading: false,
};

export const providerSlice = createSlice({
  name: 'providers',
  initialState,
  reducers: {
    getProvidersStart: (state: ProviderSliceState) => {
      state.loading = true;
    },
    getProvidersFailure: (state: ProviderSliceState) => {
      state.loading = false;
    },
    getProvidersSuccess: (state: ProviderSliceState, action: PayloadAction<ProviderEntity[]>) => {
      state.loading = false;
      state.data = action.payload;
    },
  },
});

export const { getProvidersStart, getProvidersSuccess, getProvidersFailure } =
  providerSlice.actions;
